module.exports = ".container-fluid {\n  margin-top: 100px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.component.scss
// module id = ./src/app/home/home.component.scss
// module chunks = main